export const redirectTo = (url: string) => {
  const fallbackUrl = '/';
  window.location.replace(isSafeRedirectUrl(url) ? url : fallbackUrl);
};

export const isSafeRedirectUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url, window.location.origin);

    if (!parsed.protocol.startsWith('http') || !parsed.hostname.includes('programmers.co.kr')) {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
};
